'use strict'

import ApiClient from './ApiClient'

export default class TagRepository {
  /**
   * タグの選択肢を取得する
   * @param type a: すべてのタグ, m: 共有タグ, p: 個人タグ
   * @param int page
   * @returns {*}
   */
  getOptions (type, page) {
    let model
    switch (type) {
      case 'a':
        model = 'alltags'
        break
      case 'm':
        model = 'mgtags'
        break
      case 'p':
        model = 'personal-settings/tags'
        break
      default:
        throw new Error('Invalid argument "type" for TagRepository::getOptions().')
    }
    return ApiClient().get(`/${model}/seltags`, {params: {page: page || 1}})
  }
}



// WEBPACK FOOTER //
// ./src/repositories/TagRepository.js